
import { mixins, Options } from "vue-class-component";
import GuestLayout from "@/layout/GuestLayout.vue";
import Validation from "@/components/validation/Validation.vue";
import { minLength, required, sameAs } from "@vuelidate/validators";
import { namespace } from "vuex-class";
import { GuestFormMixin } from "@/mixins/form/GuestFormMixin";

const AuthModule = namespace("auth");

@Options({
  components: { Validation, GuestLayout },
  validations() {
    return {
      password: { required, minLength: minLength(8) },
      passwordConfirmation: { required, sameAs: sameAs(this.password) },
    };
  },
})
export default class ResetPasswordChange extends mixins(GuestFormMixin) {
  private password?: string | null = null;
  private passwordConfirmation?: string | null = null;

  @AuthModule.Action("resetPasswordChange")
  private resetPasswordChangeAction: any;

  @AuthModule.Getter("getIsLoading")
  private isLoading: any;

  @AuthModule.Getter("getError")
  private error: any;

  private onSubmit(e: any): void {
    if (e) {
      (e as Event).preventDefault();
    }
    if (this.isInvalidate()) {
      return;
    }
    this.resetPasswordChangeAction({
      plainPassword: this.password,
      passwordConfirmation: this.passwordConfirmation,
      token: this.$route.query.token,
    });
  }
}
